import { createGetTransactionsReducer } from '@ppay/client'

import { getMerchantTransactionsAction, getMerchantTransactionsCSVAction } from '../../../actions'

export const get = createGetTransactionsReducer(
  getMerchantTransactionsAction,
  getMerchantTransactionsCSVAction
)
